var render = function render(){var _vm=this,_c=_vm._self._c;return _c('metric-card',[(!_vm.loading)?_c('vue-frappe',{attrs:{"id":_vm.id,"labels":_vm.labels,"type":"bar","title":"Total Organizations","height":_vm.height,"valuesOverPoints":true,"tooltipOptions":_vm.tooltips,"colors":[ '#C246F2' ],"dataSets":_vm.graphData}}):_c('loader',{attrs:{"spinner":true,"theme":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }